import { ClassNameValue } from 'tailwind-merge';
import { Alignment } from '../../types';

export const alignStyles: Partial<Record<Alignment, ClassNameValue>> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
